module.exports = __webpack_public_path__ + "static/media/prosthetics.1b90a8d3.svg";